"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }
  return to;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logger = void 0;
var pino_1 = __importDefault(require("pino"));
var loggerLevel_1 = require("./enums/loggerLevel");
var loggerPaletteName_1 = require("./enums/loggerPaletteName");
var loggerTheme_1 = require("./contants/loggerTheme");
var commonStyles = ['font-weight: bold', 'display: inline-block', 'padding: 5px 0 5px 7px'].join(';');
/**
 * To enable logging set debug item in localstorage
 * key: 'debug'
 * value: names
 * example
 * window.localStorage.setItem('debug', '@wbe/editor,@wbe/panel');
 *
 *
 * The higher debugLevel you set the more logs you see
 * FATAL - fewest logs
 * Trace - all logs
 * window.localStorage.setItem('debugLevel', 'ERROR')
 *
 * if no debugLevel is set Fatal is used
 */
var Logger = /** @class */function () {
  function Logger(options) {
    var _a, _b, _c, _d;
    this.prefixLevelToColorMap = new Map();
    if (!options || typeof options !== 'object') {
      throw new Error('options are required, and must be an object');
    }
    var debugValue = null;
    var debugLevel = null;
    if (typeof window === 'undefined' && typeof process !== 'undefined') {
      debugLevel = (_a = process.env.LOG_LEVEL) !== null && _a !== void 0 ? _a : null;
      debugValue = options.name;
    } else {
      try {
        debugValue = localStorage.getItem('debug');
        debugLevel = localStorage.getItem('debugLevel');
      } catch (e) {}
    }
    var level = ((_b = debugLevel !== null && debugLevel !== void 0 ? debugLevel : options.level) !== null && _b !== void 0 ? _b : loggerLevel_1.LoggerLevel.Fatal).toLowerCase();
    var palette = loggerTheme_1.loggerTheme[(_c = options.paletteName) !== null && _c !== void 0 ? _c : loggerPaletteName_1.LoggerPaletteName.NightEighties];
    this.name = options.name;
    this.customNameColor = (_d = options.customNameColor) !== null && _d !== void 0 ? _d : null;
    this.palette = palette;
    this.prefixLevelToColorMap.set(loggerLevel_1.LoggerLevel.Fatal, palette.Red).set(loggerLevel_1.LoggerLevel.Error, palette.Orange).set(loggerLevel_1.LoggerLevel.Warn, palette.Yellow).set(loggerLevel_1.LoggerLevel.Info, palette.Blue).set(loggerLevel_1.LoggerLevel.Debug, palette.Purple).set(loggerLevel_1.LoggerLevel.Trace, palette.Green);
    this.engine = pino_1["default"]({
      level: level,
      enabled: this.isEnabled(debugValue !== null && debugValue !== void 0 ? debugValue : ''),
      prettyPrint: options.prettyPrint
    });
  }
  Logger.prototype.isEnabled = function (debugValue) {
    var _this = this;
    return !!debugValue.split(',').reduce(function (value, scope) {
      return value || _this.prepareRegExpForPrefixSearch(scope).test(_this.name);
    }, false);
  };
  Logger.prototype.prepareRegExpForPrefixSearch = function (value) {
    return new RegExp("^" + value.replace(/\*/g, '.*?') + "$");
  };
  Logger.prototype.getLevelStyles = function (level) {
    var _a;
    var palette = this.palette;
    var color = (_a = this.prefixLevelToColorMap.get(level)) !== null && _a !== void 0 ? _a : palette.Comment;
    return "color: " + color + "; " + commonStyles + "; background: " + palette.Background + ";";
  };
  Logger.prototype.getNameStyles = function () {
    var _a;
    return commonStyles + "; color: " + ((_a = this.customNameColor) !== null && _a !== void 0 ? _a : this.palette.Aqua) + ";";
  };
  Logger.prototype.getPrefix = function (level) {
    return ["%c" + this.name + " %c| " + level.toUpperCase() + " | ", this.getNameStyles(), this.getLevelStyles(level)];
  };
  Logger.prototype.fatal = function () {
    var _a;
    var message = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      message[_i] = arguments[_i];
    }
    (_a = this.engine).fatal.apply(_a, __spreadArray(__spreadArray([], __read(this.getPrefix(loggerLevel_1.LoggerLevel.Fatal))), __read(message)));
  };
  Logger.prototype.error = function () {
    var _a;
    var message = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      message[_i] = arguments[_i];
    }
    (_a = this.engine).error.apply(_a, __spreadArray(__spreadArray([], __read(this.getPrefix(loggerLevel_1.LoggerLevel.Error))), __read(message)));
  };
  Logger.prototype.warn = function () {
    var _a;
    var message = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      message[_i] = arguments[_i];
    }
    (_a = this.engine).warn.apply(_a, __spreadArray(__spreadArray([], __read(this.getPrefix(loggerLevel_1.LoggerLevel.Warn))), __read(message)));
  };
  Logger.prototype.info = function () {
    var _a;
    var message = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      message[_i] = arguments[_i];
    }
    (_a = this.engine).info.apply(_a, __spreadArray(__spreadArray([], __read(this.getPrefix(loggerLevel_1.LoggerLevel.Info))), __read(message)));
  };
  Logger.prototype.debug = function () {
    var _a;
    var message = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      message[_i] = arguments[_i];
    }
    (_a = this.engine).debug.apply(_a, __spreadArray(__spreadArray([], __read(this.getPrefix(loggerLevel_1.LoggerLevel.Debug))), __read(message)));
  };
  Logger.prototype.trace = function () {
    var _a;
    var message = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      message[_i] = arguments[_i];
    }
    (_a = this.engine).trace.apply(_a, __spreadArray(__spreadArray([], __read(this.getPrefix(loggerLevel_1.LoggerLevel.Trace))), __read(message)));
  };
  return Logger;
}();
exports.Logger = Logger;